import { ResourcesConfig } from 'aws-amplify';

/**
 * Amplify configuration for Cognito authentication.
 * Values are sourced from environment variables at build time.
 * 
 * Required environment variables:
 * - VITE_COGNITO_USER_POOL_ID: Cognito User Pool ID (ap-southeast-2_XXXXXXXXX)
 * - VITE_COGNITO_CLIENT_ID: Cognito App Client ID
 * - VITE_COGNITO_DOMAIN: Cognito Hosted UI domain (e.g., auditmypay.auth.ap-southeast-2.amazoncognito.com)
 * - VITE_REDIRECT_SIGN_IN: Redirect URL after sign-in
 * - VITE_REDIRECT_SIGN_OUT: Redirect URL after sign-out
 */

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [import.meta.env.VITE_REDIRECT_SIGN_IN || 'http://localhost:3000/'],
          redirectSignOut: [import.meta.env.VITE_REDIRECT_SIGN_OUT || 'http://localhost:3000/'],
          responseType: 'code',
          providers: ['Apple', 'Google'],
        },
      },
    },
  },
};

export default amplifyConfig;
